import { timeoff } from '../../../lib/apiList'
import axios from '../../../lib/axios'
import {
    ApplyTimeOffRequest,
    ValidateDateRange,
    ApproveOrRejectI,
} from './type'

export const applyTimeOff = (body: ApplyTimeOffRequest): Promise<any> => {
    return axios.post(timeoff.APPLYTIMEOFF, body)
}

export const validateDateRange = (body: ValidateDateRange): Promise<any> => {
    return axios.post(timeoff.VALIDATEDATERANGE, body)
}

export const timeOffDetail = (timeOffRequestId: string): Promise<any> => {
    const url = `${timeoff.TIMEOFFDETAIL}?timeOffRequestId=${timeOffRequestId}`
    return axios.get(url)
}

export const whoElseIsOff = (): Promise<any> => {
    const body = {}
    return axios.post(timeoff.WHOELSEISOFF, body)
}

export const approveOrReject = (body: ApproveOrRejectI): Promise<any> => {
    return axios.patch(timeoff.APPROVEREJECT, body)
}

export const deleteTimeOff = (id: string): Promise<any> => {
    const url = `${timeoff.DELETETIMEOFFREQUEST}/${id}`
    return axios.delete(url)
}
